<template>
  <section>
    <general-config />
  </section>
</template>
<script>
import { mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import GeneralConfig from '@/components/configuration/forms/general-config.vue'
export default {
  name: 'ConfigHost',
  components: {
    GeneralConfig
  },
  async mounted() {
    await this.getLookups({
      keys: ['CalibrationType', 'SystemType', 'CCCItemType'],
      firm: 1,
      refresh: true
    })
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups'])
  }
}
</script>
<style lang="scss" scoped></style>
